import React, { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { INITIAL_PORTAL_INDEX_URL, RouterConfigEnum } from '@portalCommon/constants';
import { DataRouteConfig } from '@commonPackage/types';
import { LanguageLayout } from '@/layouts';
import { MainRouterWrapper } from '.';

const HomeV3 = lazy(() => import(/* webpackChunkName:"homeV3" */ '@/pages/homeV3/Home'));
const KnowUs = lazy(() => import(/* webpackChunkName:"knowUs" */ '@/pages/knowUs/index'));
const HelpCenter = lazy(() => import(/* webpackChunkName:"help" */ '@/pages/help'));
const Contact = lazy(() => import(/* webpackChunkName:"contact" */ '@/pages/contact'));
const DownloadWay = lazy(() => import(/* webpackChunkName:"downloadWay" */ '@/pages/downloadWay/index'));
const Scene = lazy(() => import(/* webpackChunkName:"scene" */ '@/pages/scene/index'));
const SceneCase = lazy(() => import(/* webpackChunkName:"sceneCase" */ '@/pages/sceneCase/index'));
const ActivityEntrance = lazy(() => import(/* webpackChunkName:"activityEntrance" */ '@/pages/activityEntrance/index'));

const Agent = lazy(() => import(/* webpackChunkName:"agent" */ '@/pages/agent/index'));
const AdMeta = lazy(() => import(/* webpackChunkName:"homeV3" */ '@/pages/adMeta'));
const CoreTechnology = lazy(() => import(/* webpackChunkName:"coreTechnology" */ '@/pages/coreTechnology'));
const Recommend = lazy(() => import('@/pages/recommend'));

const routerChildren: DataRouteConfig[] = [
  {
    index: true,
    element: <HomeV3 />,
  },
  {
    path: RouterConfigEnum.KnowUs,
    element: <KnowUs />,
  },
  import.meta.env.VITE_MAIN === 'true'
    ? {
        path: RouterConfigEnum.AdMetaH5,
        element: <AdMeta />,
      }
    : {},
  import.meta.env.VITE_MAIN === 'true'
    ? {
        path: RouterConfigEnum.HelpCenter,
        element: <HelpCenter />,
      }
    : {},
  {
    path: RouterConfigEnum.ContactUs,
    element: <Contact />,
  },
  {
    path: RouterConfigEnum.CommonContact,
    element: <Contact isCommon={true} />,
  },
  {
    path: RouterConfigEnum.AgentPage,
    element: <Agent />,
  },
  {
    path: RouterConfigEnum.DownloadWay,
    element: <DownloadWay />,
  },
  {
    path: RouterConfigEnum.Scene,
    element: <Scene />,
  },
  {
    path: RouterConfigEnum.SceneCase,
    element: <SceneCase />,
  },
  {
    path: RouterConfigEnum.EventEntrance,
    element: <ActivityEntrance />,
  },
  {
    path: RouterConfigEnum.CoreTechnology,
    element: <CoreTechnology />,
  },
  import.meta.env.VITE_MAIN === 'true'
    ? {
        path: RouterConfigEnum.Recommend,
        element: <Recommend />,
      }
    : {},
];

export const routerConfig: RouteObject[] = [
  {
    path: '/',
    element: <MainRouterWrapper />,
    children: [
      ...routerChildren,
      {
        path: ':lang',
        element: <LanguageLayout />,
        children: routerChildren,
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to={INITIAL_PORTAL_INDEX_URL} />,
  },
];
